import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import { Notification, Typography } from '@telus-uds/components-web';
import ErrorIcon from '../../../assets/images/icon_error_messages.gif';

const TelusSalesManagerForm = ({ labels, touched, errors }) => {
  return (
    <>
      <div className="main-content-form-headers">
        <Typography>{labels.XID_TID}</Typography>
      </div>
      <Notification copy="en">
        <Typography>
          <b>{labels.NOTE}</b>: Enter your full TELUS ID starting with X or T (e.g., T123456)
        </Typography>
      </Notification>
      <div
        style={{ position: 'relative' }}
        className={`input-container ${errors.xid && touched.xid ? 'error' : ''
          }`}
      >
        <Field
          placeholder="XID/TID"
          className="select-style"
          type="text"
          name="xid"
        />
        <>
          <div className="error_messages">
            <Typography>{errors.xid}</Typography>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

TelusSalesManagerForm.propTypes = {
  labels: PropTypes.objectOf(PropTypes.string).isRequired,
  touched: PropTypes.objectOf(PropTypes.bool).isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired
};

export default TelusSalesManagerForm;
